// effects/media-library.effects.ts
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ApiService } from '../../../services';
import {
  addNewMediaLibraryFiles,
  MediaLibraryFileActions,
  MediaLibraryActions,
  MediaLibraryQuotaActions,
  MediaLibraryTypesActions,
} from './media-library.actions';

@Injectable()
export class MediaLibraryEffects {
  loadMediaLibraryFiles$;
  deleteMediaLibraryFile$;
  loadMediaLibraryTypes$;
  loadMediaLibraryQuota$;

  constructor(private actions$: Actions, private api: ApiService) {
    this.loadMediaLibraryFiles$ = createEffect(() =>
      this.actions$.pipe(
        ofType(MediaLibraryActions.load),
        mergeMap(({ category }) =>
          this.api.getAllMedia(category).pipe(
            map((response) => MediaLibraryActions.loadSuccess({ files: response })),
            catchError((error) => of(MediaLibraryActions.loadFailure({ error })))
          )
        )
      )
    );

    this.deleteMediaLibraryFile$ = createEffect(() =>
      this.actions$.pipe(
        ofType(MediaLibraryFileActions.delete),
        mergeMap(({ file, force }) => {
          if (!file.id) {
            return of(MediaLibraryFileActions.deleteFailure({ fileId: 0, error: 'File ID is missing' }));
          }
          return this.api.deleteMediaById(file.id as number, force).pipe(
            mergeMap((response) => {
              if (response?.success) {
                return of(MediaLibraryFileActions.deleteSuccess({ fileId: file.id as number }));
              } else {
                return of(MediaLibraryFileActions.deleteFailure({ fileId: file.id as number, error: response }));
              }
            }),
            catchError((error) => of(MediaLibraryFileActions.deleteFailure({ fileId: file.id as number, error })))
          );
        })
      )
    );

    this.loadMediaLibraryTypes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(MediaLibraryTypesActions.load),
        mergeMap(({ uploadType }) =>
          this.api.getMediaTypes().pipe(
            map((response) => {
              const filterByType: any = {
                media: ['image', 'video'],
                image: ['image'],
                video: ['video'],
              };
              const currentFilter = filterByType[uploadType];

              if (!!currentFilter) {
                response = response.filter((type: any) =>
                  currentFilter.includes(type.name)
                );
              }

              return MediaLibraryTypesActions.loadSuccess({ types: response });
            }),
            catchError((error) => of(MediaLibraryTypesActions.loadFailure({ error })))
          )
        )
      )
    );

    this.loadMediaLibraryQuota$ = createEffect(() =>
      this.actions$.pipe(
        ofType(MediaLibraryQuotaActions.load, MediaLibraryFileActions.deleteSuccess, addNewMediaLibraryFiles),
        mergeMap(() =>
          this.api.getMediaLibraryQuota((error: any) => { throw error }).pipe(
            map((response) => {
              return MediaLibraryQuotaActions.loadSuccess({ quota: response });
            }),
            catchError((error) => of(MediaLibraryQuotaActions.loadFailure({ error })))
          )
        )
      )
    );
  }
}
